export const RRHHRoutes = [
  {
    path: '/hr',
    name: 'hr',
    component: () => import('./views/EmployeesManagement.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['RRHH', 'admin', 'supervisor', 'employee'],
    },
  },
  {
    path: '/hr/employee/:id',
    name: 'hr-employee-profile',
    component: () => import('./views/EmployeeProfile.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['RRHH', 'admin', 'supervisor', 'employee'],
    },
  },
  {
    path: '/Externalletters',
    name: 'hr-letters',
    component: () => import('./views/ExternalLetters.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['RRHH', 'admin', 'supervisor', 'employee'],
    },
  },
  {
    path: '/hr/error-reports',
    name: 'hr-error-reports',
    component: () => import('./views/ErrorReportsList.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['RRHH', 'admin'],
    },
  },
  {
    path: '/hr/error-reports/:id',
    name: 'hr-error-report-detail',
    component: () => import('./views/ErrorReportDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['RRHH', 'admin'],
    },
  },
]
